// Use local API when unset or string "undefined" (bundler can inline undefined as the string "undefined")
const branch =
  process.env.CF_PAGES_BRANCH && process.env.CF_PAGES_BRANCH !== 'undefined'
    ? process.env.CF_PAGES_BRANCH
    : 'local';

enum Environment {
  DEV = 'dev',
  MAIN = 'main',
  LOCAL = 'local',
  STAGING = 'staging',
  PROD = 'prod',
  CARDANO_POC = 'cardano-poc',
}

type Config = {
  apiBaseUrl: string;
  clerk: {
    publishableKey: string;
  };
  googleMapsApiKey: string;
};

export const configMap: Record<Environment, Config> = {
  dev: {
    apiBaseUrl: 'https://api-dev.petso.dev',
    clerk: {
      publishableKey:
        'pk_test_Y2FyaW5nLXNhbG1vbi03MC5jbGVyay5hY2NvdW50cy5kZXYk',
    },
    googleMapsApiKey: 'AIzaSyCFG6qADsP26IYQTUlAQof41KnVCerrIIU',
  },
  // "main" is the Cloudflare Pages production branch name — maps to dev config
  main: {
    apiBaseUrl: 'https://api-dev.petso.dev',
    clerk: {
      publishableKey:
        'pk_test_Y2FyaW5nLXNhbG1vbi03MC5jbGVyay5hY2NvdW50cy5kZXYk',
    },
    googleMapsApiKey: 'AIzaSyCFG6qADsP26IYQTUlAQof41KnVCerrIIU',
  },
  staging: {
    apiBaseUrl: 'https://api-staging.petso.io',
    clerk: {
      publishableKey: 'pk_test_Z3JhbmQtc3VuYmlyZC0yLmNsZXJrLmFjY291bnRzLmRldiQ',
    },
    googleMapsApiKey: 'AIzaSyCFG6qADsP26IYQTUlAQof41KnVCerrIIU',
  },

  local: {
    apiBaseUrl: 'http://localhost:8787',
    clerk: {
      publishableKey:
        'pk_test_Y2FyaW5nLXNhbG1vbi03MC5jbGVyay5hY2NvdW50cy5kZXYk',
    },
    googleMapsApiKey: 'AIzaSyCFG6qADsP26IYQTUlAQof41KnVCerrIIU',
  },
  prod: {
    apiBaseUrl: 'https://api.petso.io',
    clerk: {
      publishableKey:
        'pk_live_Y2xlcmsucGV0c28uaW8k',
    },
    googleMapsApiKey: 'AIzaSyCFG6qADsP26IYQTUlAQof41KnVCerrIIU',
  },
  // Cardano POC — isolated parallel environment on branch webappjacardano.
  // Points to api-cardano-poc.petso.dev Worker. Clerk key reuses dev for
  // sign-in compatibility with the migrated-from-dev user base.
  'cardano-poc': {
    apiBaseUrl: 'https://api-cardano-poc.petso.dev',
    clerk: {
      publishableKey:
        'pk_test_Y2FyaW5nLXNhbG1vbi03MC5jbGVyay5hY2NvdW50cy5kZXYk',
    },
    googleMapsApiKey: 'AIzaSyCFG6qADsP26IYQTUlAQof41KnVCerrIIU',
  },
};

export const config = configMap[branch as Environment] ?? configMap.dev;
